export const CONSENT__GET__START = 'CONSENT__GET__START';
export const CONSENT__GET__SUCCESS = 'CONSENT__GET__SUCCESS';
export const CONSENT__GET__FAILURE = 'CONSENT__GET__FAILURE';
export const CONSENT__GET__RESET = 'CONSENT__GET__RESET';
export const CONSENT__SET__START = 'CONSENT__SET__START';
export const CONSENT__SET__SUCCESS = 'CONSENT__SET__SUCCESS';
export const CONSENT__SET__FAILURE = 'CONSENT__SET__FAILURE';
